import { retornoHashValor } from '../../modulos/cripotografia/hash';
import api from '../backAxios';
import axios, { post, put } from 'axios';

class MidiaService {
    async buscarTodaMidias() {
        try {
            const envioLink = await api.get(
                'file-doc/busca/dinamica?modelo=zelotv-s3'                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }
    
    async buscarMidiaUrl(url) {
        try {
            const envioLink = await api.post(
                'file-doc/s3/download/arquivo', url                
            );

            return envioLink;
        } catch (error) {
            throw new Error(error);
        }
    }

    async deleteMidia(path, id) {
        const url = `${retornoHashValor(process.env.REACT_APP_1)}/file-doc/s3/${id}`;

        const config = {
            headers: {
                'content-type': 'application/json'
            }
        };

        try {
            const result = axios.delete(url,  { data: { path } }, config);

            return result;
        } catch (error) {
            console.log(error.message);

            return new Error(error);
        }
    }

    async adicionarMidia(descricao, form) {
        const url = `${retornoHashValor(process.env.REACT_APP_1)}/file-doc/s3/upload/${descricao}`;
        const formData = new FormData();

        formData.append('file',form);

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        try {
            const result = post(url, formData,config);

            return result;
        } catch (error) {
            throw new Error(error);
        }
    }

    async atualizarMidia(descricao, form, id_doc) {
        const url = `${retornoHashValor(process.env.REACT_APP_1)}/file-doc/s3/${id_doc}?descricao=${descricao}`;
        const formData = new FormData();

        formData.append('file',form);

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        try {
            const result = put(url, formData,config);

            return result;
        } catch (error) {
            throw new Error(error);
        }
    }

    async postVincularImagemIdGrupoId(imagemId, IdImagemAVinculas ) {
        try {
            const grupos = await api.post(
                `tv-telas/grupos/associar-imagem?imagem=${imagemId}`, IdImagemAVinculas
            );
           
            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async deleteDesvincularImagemIdGrupoId(imagemId, idGruposaDesvincular ) {
        try {
            const grupos = await api.delete(
                `tv-telas/grupos/desassociar-imagem?imagem=${imagemId}`,{ data: idGruposaDesvincular }
            );
           
            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default new MidiaService();
